/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';

import EmptyStateBlocksImg from './empty-state-blocks.svg';
import IssuesHighlightImg from './issues-highlight.svg';

export const EmptyStateBlocks = () => <Image src={EmptyStateBlocksImg} alt="" width={171.25} />;

const imageTopMarginStyles = css({
	marginTop: token('space.200', '16px'),
});

export const EmptyStateImage = () => (
	<Image src={IssuesHighlightImg} alt="" width={336} css={imageTopMarginStyles} />
);
